import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Detalhes ")
const _hoisted_2 = { class: "w-full flex flex-wrap" }
const _hoisted_3 = { class: "w-full md:w-5/12 bg-gray-100 rounded-sm p-4 break-all" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-blue-600" }, "Dados anteriores", -1)
const _hoisted_5 = { class: "break-words" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-2/12" }, null, -1)
const _hoisted_7 = { class: "w-full md:w-5/12 bg-gray-100 rounded-sm p-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-blue-600" }, "Dados atualizados", -1)
const _hoisted_9 = { class: "break-words" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true)),
      type: "info",
      size: "small"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_n_modal, {
      show: _ctx.showModal,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event)),
      "mask-closable": false,
      class: "w-full md:w-1/2",
      preset: "card",
      title: "Histórico de edição"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.historic.old_data), 1)
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.historic.data), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}